import { motion, AnimatePresence } from 'framer-motion';
import { useToast } from '../../context/ToastContext';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';

export default function ToastContainer() {
  const { toasts, removeToast } = useToast();

  const getToastConfig = (type) => {
    switch (type) {
      case 'success':
        return {
          icon: <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" />,
          borderColor: 'border-emerald-500/50',
          shadowColor: 'shadow-emerald-500/20'
        };
      case 'error':
        return {
          icon: <XCircle className="w-5 h-5 text-primary-500 shrink-0 mt-0.5" />,
          borderColor: 'border-primary-500/50',
          shadowColor: 'shadow-primary-500/20'
        };
      case 'warning':
        return {
          icon: <AlertTriangle className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />,
          borderColor: 'border-amber-500/50',
          shadowColor: 'shadow-amber-500/20'
        };
      default:
        return {
          icon: <Info className="w-5 h-5 text-blue-500 shrink-0 mt-0.5" />,
          borderColor: 'border-blue-500/50',
          shadowColor: 'shadow-blue-500/20'
        };
    }
  };

  return (
    <div className="fixed bottom-5 right-5 z-[200] flex flex-col gap-3 pointer-events-none" dir="rtl">
      <AnimatePresence>
        {toasts.map((toast) => {
          const config = getToastConfig(toast.type);
          
          return (
            <motion.div
              key={toast.id}
              initial={{ opacity: 0, x: 50, scale: 0.9 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }}
              transition={{ type: "spring", stiffness: 300, damping: 25 }}
              className={`pointer-events-auto flex items-start gap-4 p-4 rounded-2xl bg-zinc-900/90 backdrop-blur-md border border-slate-200/10 ${config.borderColor} shadow-lg ${config.shadowColor} w-80 max-w-[90vw] overflow-hidden group`}
            >
              {config.icon}
              <p className="flex-1 text-sm font-bold text-white leading-relaxed pt-0.5 font-sans">
                {toast.message}
              </p>
              <button
                onClick={() => removeToast(toast.id)}
                className="shrink-0 p-1 rounded-lg text-zinc-400 hover:text-white hover:bg-white/10 transition-colors opacity-50 group-hover:opacity-100"
              >
                <X className="w-4 h-4" />
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
